import {Loader} from "react-feather";

export default function Loading() {
    return (
        <div className="flex items-center justify-center h-full">
            <Loader className="animate-spin text-unibaRed" size="48"/>
        </div>
    )
}